import React from 'react';
import {Link} from 'react-router-dom';
import {InstagramFilled, PinterestFilled, SendOutlined} from '@ant-design/icons';

import {
    CATALOG,
    DELIVERY,
    DOC_OFFER,
    DOC_POLICY,
    LINK_PINTEREST,
    LINK_TELEGRAM
} from '../../config/routes';
import logo from '../Header/logo.svg';

import cls from './Footer.module.scss'

export const Footer = () => (
    <footer className={cls.footer}>

        <div className={cls.gray}/>

        <div className={'content'}>
            <div className={cls.wrapper}>
                <div className={cls.spanOne}><img src={logo} alt={'Daisy Logo'} className={cls.logo}/></div>
                <div className={cls.links}>
                    <h3>Контакты</h3>
                    <div><a href={'tel:+79104280272'} target={'_blank'} rel={'noreferrer'}>+7 (910) 428-02-72</a></div>
                    <div><a href={'mailto:info@daisycandels.ru'} target={'_blank'} rel={'noreferrer'}>info@daisycandels.ru</a>
                    </div>
                </div>
                <div className={cls.links}>
                    <h3>Документы</h3>
                    <div><a href={DOC_POLICY} target={'_blank'} rel={'noreferrer'}>Политика конфиденциальности</a></div>
                    <div><a href={DOC_OFFER} target={'_blank'} rel={'noreferrer'}>Публичная оферта</a></div>
                </div>
                <div className={cls.links}>
                    <h3>Покупателям</h3>
                    <div><Link to={CATALOG}>Каталог</Link></div>
                    <div><Link to={DELIVERY}>Доставка и оплата</Link></div>
                </div>
                <div className={cls.links}>
                    <div><PinterestFilled/> <a href={LINK_PINTEREST} target={'_blank'} rel={'noreferrer'}>Pinterest</a>
                    </div>
                    <div><SendOutlined/> <a href={LINK_TELEGRAM} target={'_blank'} rel={'noreferrer'}>Telegram</a></div>
                    <div><InstagramFilled/> @daisy_candles_store</div>
                </div>
                <div>ИП Винская Ирина Сергеевна</div>
                <div className={cls.spanTwo}></div>
                <div>© 2025</div>
            </div>
        </div>
    </footer>
)